// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__QPn2y","background":"Layout_background__k4Q2T","main":"Layout_main__o1zW1"};